import it from './it'
import en from './en'

export default {
  en,
  it
}
